import React, { useState } from 'react';
import { Link, useLocation, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './AppShell.css';

const NAV = [
  {
    section: 'Admin',
    roles: ['admin'],
    items: [
      { path: '/admin/markets', label: 'Markets' },
      { path: '/admin/products', label: 'Products' },
      { path: '/admin/users', label: 'Users' },
      { path: '/admin/market-products', label: 'Market Products' },
      { path: '/admin/packing-assignments', label: 'Packing Assignments' },
      { path: '/admin/intercompany', label: 'Intercompany' },
      { path: '/admin/settings', label: 'Settings' },
      { path: '/admin/reports', label: 'Reports' },
    ],
  },
  {
    section: 'Operations',
    roles: ['admin', 'manager', 'market_staff'],
    items: [
      { path: '/ops/market-days', label: 'Market Days' },
      { path: '/ops/pack-lists', label: 'Pack Lists' },
      { path: '/ops/farm-store', label: 'Farm Store' },
      { path: '/ops/production-log', label: 'CC Production Log' },
      { path: '/ops/butcher-log', label: 'Butcher Log' },
      { path: '/ops/mustard-dip', label: 'Mustard & Dip' },
      { path: '/ops/payroll', label: 'Payroll' },
    ],
  },
];

export default function AppShell() {
  const { user, logout, hasRole } = useAuth();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const visibleSections = NAV.filter((s) => hasRole(...s.roles));

  return (
    <div className={`shell ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
      <aside className="sidebar">
        <div className="sidebar-top">
          <div className="sidebar-brand">
            <span className="sb-arf">ARF</span>
            <span className="sb-x">x</span>
            <span className="sb-cc">CC</span>
          </div>
          <button className="sidebar-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
            {sidebarOpen ? '<' : '>'}
          </button>
        </div>
        <nav className="sidebar-nav">
          {visibleSections.map((section) => (
            <div key={section.section} className="nav-section">
              <span className="nav-section-label">{section.section}</span>
              {section.items.map((item) => (
                <Link
                  key={item.path}
                  to={item.disabled ? '#' : item.path}
                  className={[
                    'nav-item',
                    location.pathname.startsWith(item.path) ? 'active' : '',
                    item.disabled ? 'disabled' : '',
                  ].join(' ')}
                  onClick={(e) => item.disabled && e.preventDefault()}
                >
                  <span className="nav-label">{item.label}</span>
                  {item.badge && <span className="nav-badge">{item.badge}</span>}
                </Link>
              ))}
            </div>
          ))}
        </nav>
        <div className="sidebar-user">
          {user?.picture && (
            <img src={user.picture} alt={user.name} className="user-avatar" referrerPolicy="no-referrer" />
          )}
          <div className="user-info">
            <span className="user-name">{user?.name}</span>
            <span className="user-role">{user?.role}</span>
          </div>
          <button className="logout-btn" onClick={logout}>out</button>
        </div>
      </aside>
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
